import api from './api';

export const adminAPI = {
 getAdminDashboard: (params = {}) => api.get(`/admin/admin-dashboard`, { params }),
  
};